import { VisitNodePassage } from "../../types";
const getCustomMeasureValue = (element, configurationItem) => {
    if (configurationItem.source) {
        return element.measures?.[configurationItem.source];
    }
    return configurationItem.value;
};
const createCustomMeasuresObject = (element, customMeasureConfiguration) => {
    const customMeasures = {};
    Object.keys(customMeasureConfiguration).forEach((key) => {
        if (Array.isArray(customMeasureConfiguration[key])) {
            const customMeasureConfigurationItems = customMeasureConfiguration[key];
            customMeasures[key] = customMeasureConfigurationItems.map((item) => getCustomMeasureValue(element, item));
        }
        else {
            const customMeasureConfigurationItem = customMeasureConfiguration[key];
            customMeasures[key] = getCustomMeasureValue(element, customMeasureConfigurationItem);
        }
    });
    return customMeasures;
};
export const addCustomMeasuresVisitor = (customMeasureConfigurations) => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.Leaf) {
        return;
    }
    const { visitable: element } = args;
    element.customMeasures = {};
    Object.keys(customMeasureConfigurations).forEach((key) => {
        if (element.customMeasures) {
            element.customMeasures[key] = createCustomMeasuresObject(element, customMeasureConfigurations[key]);
        }
    });
};
